import { ChangeDetectorRef, Component, NgZone, ViewChild } from '@angular/core';
import { MenuController, IonInfiniteScroll, LoadingController, AlertController, NavController, ModalController, ActionSheetController, Platform, ToastController } from '@ionic/angular';
import { BasePage } from 'src/pages/base.page';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { LoadingComponent } from 'projects/core/src/lib/core/Loading.component';
import { RecomendacaoModel } from 'projects/core/src/lib/core/model/RecomendacaoModel';
import { AlertComponent } from 'projects/core/src/lib/core/Alert.component';
import { RecomendacoesOpcoesViewModel } from './RecomendacoesViewModel';
import { ThrowError } from 'projects/core/src/lib/core/ThrowError';
import { DataUtil } from 'projects/core/src/lib/core/DataUtil';
import { AppSession } from 'projects/core/src/lib/core/AppSession';
import { AppStorage } from 'projects/core/src/lib/core/AppStorage';
import { BottomDrawerComponent } from 'src/app/components/bottom-drawer/bottom-drawer.component';
import { PurchaseRecommendationsComponent } from 'src/app/components/purchase-recommendations/purchase-recommendations.component';
import { Subject } from 'rxjs';
import { RecomendacaoMenuModel } from 'projects/core/src/lib/core/model/RecomendacaoMenuModel';
import { ChaveContratoEnum } from 'projects/core/src/lib/core/ChaveContratoEnum';
import { ContratoMenuModel } from 'projects/core/src/lib/core/model/ContratoMenuModel';
import { HelperMenuContrato } from 'projects/core/src/lib/core/HelperMenuContrato';
import { NavegaTelaPlanoImpl } from 'src/pages/plano-ios/NavegaTelaPlanoImpl';
import { ContratoWrapperModel } from 'projects/core/src/lib/core/model/ContratoWrapperModel';
import { PlanoDialog } from 'src/pages/plano/plano.dialog';
import { ContratoModel } from 'projects/core/src/lib/core/model/ContratoModel';
import { AnaliseAtivosModel } from 'projects/core/src/lib/core/model/AnaliseAtivosModel';
import { Location } from '@angular/common';
import { OptionsRecommentationsViewModel } from './../../app/components/options-strategy/OptionsRecommendationsViewModel';

enum Tipos {
  "ativas" = 1,
  "encerradas" = 2,
}

type Ponta = {
  codigo: string
  compra: number
  estilo_opcao: string
  preco_atual: number
  quantidade: number
  strike: number
  tipo_ativo: string
  tipo_opcao: string
  vencimento: string
}


enum Recomedacoes {
  'B' = 'Ações Brasil',
  'EUA' = 'Ações EUA',
  'C' = 'Criptoativos',
  'FII' = 'FIIs',
  'ETF' = 'ETFs',
  'INDICE' = 'Índices',
  'BDR' = 'BDRs'
}

@Component({
  selector: 'app-recomendacoes-opcoes',
  templateUrl: './recomendacoes-opcoes.page.html',
  styleUrls: ['./recomendacoes-opcoes.page.scss'],
})
export class RecomendacoesOpcoesPage extends BasePage implements NavegaTelaPlanoImpl {

  @ViewChild('drawer') drawer: BottomDrawerComponent;
  @ViewChild('recommendations') recommendations: PurchaseRecommendationsComponent;
  @ViewChild(IonInfiniteScroll) infiniteScroll: IonInfiniteScroll;

  idTipoRecomendacao: number = 1
  primeiraRequisicao = [false, false]

  tituloPagina: String = "Opções"
  filtroEncerradas: String = ""
  favoritos = []

  TIPO_ATIVAS = "ativas"
  TIPO_ENCERRADAS = "encerradas"

  STATUS_ABERTO = 'aberto'
  STATUS_ENCERRADO = 'encerrado'

  aba = this.TIPO_ATIVAS
  encerradoAtivo = false;
  drawerState

  OptionsRecommentationsViewModel: OptionsRecommentationsViewModel

  recomendacaoTodas: Array<RecomendacaoModel> = []

  recomendacaoCompra: Array<RecomendacaoModel> = []
  recomendacaoVenda: Array<RecomendacaoModel> = []
  recomendacaoEncerrados: Array<RecomendacaoModel> = []

  recomendacoesViewModel: RecomendacoesOpcoesViewModel
  loadingComponent: LoadingComponent
  alertComponent: AlertComponent
  loading: HTMLIonLoadingElement
  data: any
  requestSwipUp: Boolean = false
  tipoAtivo: string = RecomendacaoMenuModel.TIPO_ACOES_BOLSA
  idAtivo = new Subject<number>()
  newState$ = new Subject<string>()
  contratoWrapper: ContratoWrapperModel
  push = false
  constanteContrato = [{
    tipoAtivo: RecomendacaoMenuModel.TIPO_ACOES_BOLSA,
    chaveContrato: [ChaveContratoEnum.CONTRATO_RECOMENDACAO_ACOES]
  }, {
    tipoAtivo: RecomendacaoMenuModel.TIPO_EUA,
    chaveContrato: [ChaveContratoEnum.CONTRATO_RECOMENDACAO_EUA]
  }, {
    tipoAtivo: RecomendacaoMenuModel.TIPO_CRIPTOMOEDAS,
    chaveContrato: [ChaveContratoEnum.CONTRATO_RECOMENDACAO_CRIPTOMOEDAS]
  }, {
    tipoAtivo: RecomendacaoMenuModel.TIPO_FUNDOS_IMOBILIARIOS,
    chaveContrato: [ChaveContratoEnum.CONTRATO_RECOMENDACAO_FUNDOS_IMOBILIARIOS]
  }, {
    tipoAtivo: RecomendacaoMenuModel.TIPO_FUNDOS_INDICE,
    chaveContrato: [ChaveContratoEnum.CONTRATO_RECOMENDACAO_FUNDOS_INDICES]
  }, {
    tipoAtivo: RecomendacaoMenuModel.TIPO_INDICES,
    chaveContrato: [ChaveContratoEnum.CONTRATO_RECOMENDACAO_INDICES]
  }, {
    tipoAtivo: RecomendacaoMenuModel.TIPO_BDR,
    chaveContrato: [ChaveContratoEnum.CONTRATO_RECOMENDACAO_BDR]
  }]

  listaAnaliseAtivosViewMap = {};

  listaAnaliseAtivosView = [];//0=B, 1=EUA, 2=C

  constructor(
    private location: Location,
    private zone: NgZone,
    public router: Router,
    private menuCtrl: MenuController,
    private modalCtrl: ModalController,
    private actionSheetController: ActionSheetController,
    public loadingController: LoadingController,
    private changeDetectorRef: ChangeDetectorRef,
    private activatedRoute: ActivatedRoute,
    private platform: Platform,
    public toastCtrl: ToastController
  ) {
    super(router)
  }

  async ngOnInit() {
    super.ngOnInit()
    this.iniciarVariaveis()
    this.limpaNotificacoesLocal()

    this.listaAnaliseAtivosView[0] = []
    this.listaAnaliseAtivosView[1] = []

    let el = this
    el.platform.ready().then(() => {
      el.platform.pause.subscribe(() => {
        el.recomendacoesViewModel.finishWebSocket()
      });
      el.platform.resume.subscribe(async () => {
        if (el.router.url.startsWith('/navigation/recomendacoes')) {
          el.zone.run(async () => {
            this.handlerStartWebSocket(true)
          });
        }
      });
    });
  }

  // async ionViewDidLeave() {
  //   await this.recomendacoesViewModel.setPreferenciaUsuario(this.tipoAtivo)
  // }

  async ionViewWillEnter() {
    // this.location.replaceState(`/navigation/recomendacoes/default`);
    console.log('Entrou em Recomendações');

    this.resetAll()


    
    this.recomendacoesViewModel.buscaContratos()
    await this.getExtras()
    await this.handlerStartWebSocket(true)
  }

  async handlerStartWebSocket(instanciaWebsocket = false) {
    if (instanciaWebsocket) {
      this.recomendacoesViewModel.finishWebSocket();
      await this.recomendacoesViewModel.initWebSocket(async () => {
        await this.recomendacoesViewModel.sendMessageSocketByTipoAtivo(this.getListaCodigoAtivos())
      });
    } else {
      await this.recomendacoesViewModel.sendMessageSocketByTipoAtivo(this.getListaCodigoAtivos())
    }
  }

  async ionViewWillLeave() {
    this.handleOpenDrawer()
    this.recomendacoesViewModel.finishWebSocket()
  }

  private handleOpenDrawer() {
    this.drawer.state === 'top'
      && this.drawer.toggleDrawer();
  }

  async btnAbrirAtivo(idRecomendacao: number) {
    this.idAtivo.next(idRecomendacao)
    this.drawer.toggleDrawer()
  }

  listMergeFavoriteWithRecomendations(listRecomendations, listFavorites) {
    const listTemp = []
    const favoritosTemp = []
    listRecomendations.forEach(item => {
      if (listFavorites.indexOf(item.id) >= 0) {
        item.favorito = true
        favoritosTemp.push(item)
      } else {
        listTemp.push(item)
      }
    })
    return [...favoritosTemp, ...listTemp]
  }

  async getExtras() {
    await this.recomendacoesViewModel.buscaContratos()

    let loading = await this.showLoading()

    let chaveContrato: any = {
      tipoAtivo: RecomendacaoMenuModel.TIPO_ACOES_BOLSA,
      chaveContrato: [ChaveContratoEnum.CONTRATO_RECOMENDACAO_OPCOES_BRASIL]
    }

    if (!await this.verificaPermissaoFeature(chaveContrato)) {
      this.openPage('/navigation/home')
      this.exibeDialogPlano()
    } else {
      await this.buscaTodosOsDados()

      const idAtivo = Number.parseInt(this.activatedRoute.snapshot.paramMap.get('idAtivo'));
      
      if (idAtivo) {
        this.push = true;
        this.btnAbrirAtivo(idAtivo)
      }

      const ativo = this.activatedRoute.snapshot.paramMap.get('tipoAtivo');
      console.log(ativo);

      this.tipoAtivo = ativo;

      if (ativo === 'default') {
        let preferencia = await this.recomendacoesViewModel.getPreferenciaUsuario();
        if (preferencia) {
          this.tipoAtivo = preferencia;
        }
      }
    }

    loading.dismiss()
  }

  toUpperLowerCase(text: String) {
    let aux = String(text).toLowerCase()
    if (aux.length > 0) {
      aux = aux.substr(0, 1).toUpperCase() + aux.substr(1, aux.length - 1)
    }
    return aux
  }

  async iniciarVariaveis() {
    this.loadingComponent = new LoadingComponent(this.loadingController)
    this.recomendacoesViewModel = new RecomendacoesOpcoesViewModel()
    this.OptionsRecommentationsViewModel = new OptionsRecommentationsViewModel()
    this.recomendacoesViewModel.setContext(this)
  }

  private retornaTipoAtivoPermitido(): string {
    for (let i in this.constanteContrato) {
      if (this.constanteContrato[i].tipoAtivo == this.tipoAtivo && this.verificaPermissaoFeature(this.constanteContrato[i])) {
        return this.tipoAtivo
      }
    }

    for (let i in this.constanteContrato) {
      if (this.verificaPermissaoFeature(this.constanteContrato[i])) {
        return this.constanteContrato[i].tipoAtivo
      }
    }
    throw Error()
  }

  setListaContratos(contratoWrapper: ContratoWrapperModel) {
    this.contratoWrapper = contratoWrapper
  }

  async updateDrawerState(newState: string) {
    this.drawerState = newState;
    this.newState$.next(newState);
    if (newState != "top") {
      this.recomendacoesViewModel.resetOffset()

      this.listaAnaliseAtivosView[0] = []
      this.listaAnaliseAtivosView[1] = []

      this.recomendacaoTodas = []
      this.recomendacaoEncerrados = []

      await this.requisitaPorAba(this.aba, this.aba != this.TIPO_ENCERRADAS)
    }
    this.changeDetectorRef.detectChanges();
  }

  async navegaTelaPlano(urlContratar) {
    const modalBoasVindas = await this.modalCtrl.create({
      component: PlanoDialog,
      componentProps: {
        urlContratar
      }
    });
    modalBoasVindas.present();
  }

  async validaPermissaoFuncionalidade() {
    let loading = null;
    try {
      loading = await this.showLoading()

      let chaveContrato: any = {
        tipoAtivo: RecomendacaoMenuModel.TIPO_ACOES_BOLSA,
        chaveContrato: [ChaveContratoEnum.CONTRATO_RECOMENDACAO_OPCOES_BRASIL]
      }

      if (!await this.verificaPermissaoFeature(chaveContrato)) {
        this.openPage('/navigation/home')
      } else {
        await this.buscaTodosOsDados()
      }
    } catch (e) {
      //this.showAlert(ThrowError.TITLE_DEFAULT, 'Não foi possível obter as informações no momento. Tente novamente')
    }
    if (loading != null) {
      loading.dismiss()
    }
  }

  async buscaTodosOsDados() {
    await this.requisitaPorAba(this.aba)
  }

  formataData(data: String): String {
    try {
      var literalMes = DataUtil.getLiteralMes(Number.parseInt(data.split('-')[1]))
      return literalMes.toLocaleUpperCase().substr(0, 3) + '/' + data.split('-')[0].substr(2, 2)
    } catch (e) { }
    return ''
  }

  selecionaFiltro(tipoFiltro: String) {
    if (this.filtroEncerradas == tipoFiltro) {
      this.filtroEncerradas = ''
    } else {
      this.filtroEncerradas = tipoFiltro
    }
    this.recomendacoesViewModel.resetOffset()
    this.requisitaPorAba(this.aba, true)
  }

  toggleEncerradas(aba) {
    if (this.aba === 'encerrados') {
      this.aba = Tipos[this.idTipoRecomendacao]
      this.encerradoAtivo = false
    } else {
      this.aba = aba
      this.encerradoAtivo = true
    }
  }

  async showAlert(title: string, message: string, handler?): Promise<HTMLIonAlertElement> {
    const alert = await AlertComponent.showAlert(title, message, handler)
    return alert
  }

  async showLoading() {
    return await this.loadingComponent.showLoading()
  }

  setListaRecomendacaoTodas(listaTodas: Array<RecomendacaoModel>) {
    if (this.requestSwipUp) {
      this.recomendacaoTodas = this.recomendacaoTodas.concat(listaTodas)
      this.requestSwipUp = false
    } else {
      this.recomendacaoTodas = listaTodas
    }
    this.recomendacaoTodas.map((ativo) => {
      ativo.titulo_estrategia = ativo.titulo_estrategia.split("\n")[0]
    })
  }

  setListaRecomendacaoEncerrados(listaEncerrados: Array<RecomendacaoModel>) {
    if (this.requestSwipUp) {
      this.recomendacaoEncerrados = this.recomendacaoEncerrados.concat(listaEncerrados)
      this.requestSwipUp = false
    } else {
      this.recomendacaoEncerrados = listaEncerrados
    }
  }

  async changeSegment() {
    this.recomendacoesViewModel.resetOffset()
    await this.requisitaPorAba(this.aba)
    this.changeDetectorRef.detectChanges();

  }

  getListaCodigoAtivos(): Array<String> {
    let aux: Array<String> = []
    this.listaAnaliseAtivosView.forEach((item) => {
      item.forEach((a) => {
        aux.push(a.codigo_ativo_objeto)
      })
    })
    return aux
  }

  itemDividerHeaderFavoritos(record, recordIndex, records) {
    if (recordIndex == 0 && record.favorito) {
      return 1;
    } else if (recordIndex > 0 && records[recordIndex - 1].favorito && !record.favorito) {
      return 2
    }
    return null;
  }

  async requisitaPorAba(aba: string, novaRequisicao: boolean = false) {
    let loading = null;
    console.log(this.tipoAtivo);

    await this.recomendacoesViewModel.setPreferenciaUsuario(this.tipoAtivo)
    this.location.replaceState(`/navigation/recomendacoes-opcoes/${this.tipoAtivo}`);

    try {
      this.favoritos = await this.OptionsRecommentationsViewModel.getListaFavoritos(this.tipoAtivo)
      switch (aba) {
        case this.TIPO_ATIVAS:
          this.idTipoRecomendacao = Tipos[aba]
          if (this.recomendacaoTodas.length <= 0 || novaRequisicao) {
            loading = await this.showLoading()
            await this.recomendacoesViewModel.getRecomedacoesTodas(this.tipoAtivo)
            this.primeiraRequisicao[0] = true
            this.listaAnaliseAtivosView[0] = this.listMergeFavoriteWithRecomendations(this.recomendacaoTodas, this.favoritos)
            this.recomendacaoTodas.length > 0 && this.mapAll()
          }
          break;
        case this.TIPO_ENCERRADAS:
          if (this.recomendacaoEncerrados.length <= 0 || novaRequisicao) {
            loading = await this.showLoading()
            await this.recomendacoesViewModel.getRecomedacoesEncerradasTodas(this.tipoAtivo)
            this.primeiraRequisicao[1] = true
            this.listaAnaliseAtivosView[1] = this.recomendacaoEncerrados
            this.recomendacaoEncerrados.length > 0 && this.mapAll()
          }
          break;
      }


    } catch (e) {
      this.showAlert(ThrowError.TITLE_DEFAULT, 'Não foi possível obter a listagem de recomendações. Tente novamente')
    }
    if (loading != null) {
      loading.dismiss()
    }
  }

  async showToast(message: string) {
    let toast = await this.toastCtrl.create({
      message,
      duration: 3000,
      position: 'top'
    });
    toast.present();
  }

  async mapAll() {
    let mapTemp = {}

    for (let i = 0; i < this.listaAnaliseAtivosView.length; i++) {
      for (let j = 0; j < this.listaAnaliseAtivosView[i].length; j++) {
        mapTemp[this.listaAnaliseAtivosView[i][j].codigo_ativo_objeto.toString()] = {
          lista: i,
          indice: j
        }
      }
    }

    this.listaAnaliseAtivosViewMap = { ...mapTemp }

    await this.handlerStartWebSocket(false)
  }

  async swipDown(event) {
    this.recomendacoesViewModel.resetOffset()
    await this.requisitaPorAba(this.aba, true)
    event.target.complete();
  }

  openMenu() {
    this.menuCtrl.enable(true, 'first');
    this.menuCtrl.open('first');
  }

  async swipUp(event) {
    this.requestSwipUp = true
    this.recomendacoesViewModel.addOffset()
    await this.requisitaPorAba(this.aba, true)
    event.target.complete();
  }

  toggleInfiniteScroll() {
    this.infiniteScroll.disabled = !this.infiniteScroll.disabled;
  }

  limpaNotificacoesLocal() {
    AppStorage.remove(AppSession.CHAVE_LISTA_NOTIFICACOES);
  }

  verificaPermissaoFeature(contrato: any) {
    return ContratoModel.verificaMenuLiberadoPorContrato(contrato, this.contratoWrapper.contratos)
  }

  exibeDialogPlano() {
    HelperMenuContrato.navegaTelaPlanos(this.contratoWrapper.url_contratar)
  }

  resetAll() {
    this.aba = this.TIPO_ATIVAS
    this.recomendacoesViewModel.resetOffset()

    this.listaAnaliseAtivosView[0] = []
    this.listaAnaliseAtivosView[1] = []

    this.recomendacaoTodas = []
    this.recomendacaoEncerrados = []
    this.primeiraRequisicao = [false, false]
  }

  async presentActionSheet() {
    let buttons = [{
      text: 'Ações Brasil',
      cssClass: 'btn-action-sheet',
      handler: () => {
        if (!this.verificaPermissaoFeature(this.constanteContrato[0])) {
          this.exibeDialogPlano()
        } else {
          this.resetAll();
          this.openPage('navigation/recomendacoes/'+RecomendacaoMenuModel.TIPO_ACOES_BOLSA);
        }
      }
    }, {
      text: 'Opções',
      cssClass: 'btn-action-sheet',
      handler: () => {
        if (!this.verificaPermissaoFeature({
          tipoAtivo: RecomendacaoMenuModel.TIPO_ACOES_BOLSA,
          chaveContrato: [ChaveContratoEnum.CONTRATO_RECOMENDACAO_OPCOES_BRASIL]
        })) {
          this.exibeDialogPlano()
        } else {
          return;
        }
      }
    }, {
      text: 'Criptoativos',
      cssClass: 'btn-action-sheet',
      handler: () => {
        if (!this.verificaPermissaoFeature(this.constanteContrato[2])) {
          this.exibeDialogPlano()
        } else {
          this.resetAll();
          this.openPage('navigation/recomendacoes/'+RecomendacaoMenuModel.TIPO_CRIPTOMOEDAS);
        }
      }
    }, {
      text: 'Ações EUA',
      cssClass: 'btn-action-sheet',
      handler: () => {
        if (!this.verificaPermissaoFeature(this.constanteContrato[1])) {
          this.exibeDialogPlano()
        } else {
          this.resetAll();
          this.openPage('navigation/recomendacoes/'+RecomendacaoMenuModel.TIPO_EUA);
        }
      }
    }, {
      text: 'BDRs',
      cssClass: 'btn-action-sheet',
      handler: () => {
        if (!this.verificaPermissaoFeature(this.constanteContrato[6])) {
          this.exibeDialogPlano()
        } else {
          this.resetAll();
          this.openPage('navigation/recomendacoes/'+RecomendacaoMenuModel.TIPO_BDR);
        }
      }
    }/*, {
      text: 'Fundos Imobiliários (FIIs)',
      cssClass: 'btn-action-sheet',
      handler: () => {
        if (!this.verificaPermissaoFeature(this.constanteContrato[3])) {
          this.exibeDialogPlano()
        } else {
          this.resetAll();
          this.openPage('navigation/recomendacoes/'+RecomendacaoMenuModel.TIPO_FUNDOS_IMOBILIARIOS);
        }
      }
    }, {
      text: 'Fundos de Índices (ETFs)',
      cssClass: 'btn-action-sheet',
      handler: () => {
        if (!this.verificaPermissaoFeature(this.constanteContrato[4])) {
          this.exibeDialogPlano()
        } else {
          this.resetAll();
          this.openPage('navigation/recomendacoes/'+RecomendacaoMenuModel.TIPO_FUNDOS_INDICE);
        }
      }
    }, {
      text: 'Índices Setoriais',
      cssClass: 'btn-action-sheet',
      handler: () => {
        if (!this.verificaPermissaoFeature(this.constanteContrato[5])) {
          this.exibeDialogPlano()
        } else {
          this.resetAll();
          this.openPage('navigation/recomendacoes/'+RecomendacaoMenuModel.TIPO_INDICES);
        }
      }
    }*/, {
      text: 'Cancelar',
      role: 'cancel',
      cssClass: 'btn-action-sheet',
      handler: () => {
        console.log('Cancel clicked');
      }
    }]

    const actionSheet = await this.actionSheetController.create({
      header: "Tipo de seleção",
      mode: 'ios',
      buttons
    });

    await actionSheet.present();

    this.handleOpenDrawer();
  }

  preco_atual_atualizado(ativo) {
    const pontas = ativo.pontas as Ponta[];
    const preco_atual_atualizado = pontas.reduce((previous, current) => { return (current.quantidade * current.preco_atual) + previous }, 0)
    return preco_atual_atualizado.toFixed(ativo.decimal_places);
  }
}
